// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-container{position:relative}.modal-container .modal-container__loader{position:absolute;width:100%;height:100%;z-index:10;display:none;text-align:center}.modal-container .modal-container__loader .loader-overlay{position:relative;top:45%}.modal-container .modal-container__loader.modal-container__active{z-index:100;background-color:white;opacity:0.9;display:block}\n", ""]);
// Exports
module.exports = exports;
